import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export var getToolbarComponents = function getToolbarComponents(componentRegistry, editorState) {
  return (editorExperiment('platform_editor_controls', 'variant1', {
    exposure: true
  }) ? toolbarConfigurationV2 : toolbarConfiguration).filter(function (toolbarElement) {
    return typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState);
  }).reduce(function (acc, toolbarElement) {
    if (componentRegistry.has(toolbarElement.name)) {
      var component = componentRegistry.get(toolbarElement.name);
      if (!!component) {
        acc.push(component);
      }
    }
    return acc;
  }, []);
};
var undoRedoGroup = [{
  name: 'undoRedoPlugin'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry) {
    return componentRegistry.has('undoRedoPlugin');
  }
}];
var spellCheckGroup = [{
  name: 'spellCheck'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry) {
    return componentRegistry.has('spellCheck');
  }
}];
var blockTypeGroup = [{
  name: 'blockType'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry, editorState) {
    return componentRegistry.has('blockType') &&
    // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
    !!editorState.schema.nodes.heading;
  }
}];
var textFormattingGroup = [{
  name: 'textFormatting'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry) {
    return componentRegistry.has('textFormatting');
  }
}];
var alignmentGroup = [{
  name: 'alignment'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry) {
    return componentRegistry.has('alignment');
  }
}];
var textColorGroup = [{
  name: 'textColor'
}, {
  name: 'highlight'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry) {
    return componentRegistry.has('textColor') || componentRegistry.has('highlight');
  }
}];
var listFormattingGroup = [{
  name: 'toolbarListsIndentation'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry) {
    return componentRegistry.has('toolbarListsIndentation');
  }
}];
var hyperlinkGroup = [{
  name: 'hyperlink'
}, {
  name: 'separator',
  enabled: function enabled(componentRegistry) {
    return componentRegistry.has('hyperlink');
  }
}];
var insertBlockGroup = [{
  name: 'insertBlock'
}];
var others = [{
  name: 'beforePrimaryToolbar'
}, {
  name: 'avatarGroup'
}, {
  name: 'findReplace'
}, {
  // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
  name: 'aiExperience'
}, {
  name: 'loom'
}];
var toolbarConfiguration = [].concat(undoRedoGroup, spellCheckGroup, blockTypeGroup, textFormattingGroup, alignmentGroup, textColorGroup, listFormattingGroup, insertBlockGroup, others);
var toolbarConfigurationV2 = [].concat(blockTypeGroup, textFormattingGroup, textColorGroup, alignmentGroup, listFormattingGroup, hyperlinkGroup, [{
  name: 'overflowMenu'
}, {
  name: 'beforePrimaryToolbar'
}]);